import { render, staticRenderFns } from "./UMLVOClass.vue?vue&type=template&id=56c4df5d&scoped=true&"
import script from "./UMLVOClass.vue?vue&type=script&lang=js&"
export * from "./UMLVOClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4df5d",
  null
  
)

export default component.exports